module.exports = __webpack_public_path__ + "img/maria-de-mouraria.3b3525e2.jpg";